import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tenantsApi } from '../api/tenants.api';
import { tenantsKeys } from './queryKeys';

interface ToggleTenantStatusParams {
  tenantId: string;
  reason: string;
  action: 'suspend' | 'reactivate';
}

export const useToggleTenantStatus = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ tenantId, reason, action }: ToggleTenantStatusParams) => {
      const data = { reason };
      return action === 'suspend'
        ? tenantsApi.suspendTenant(tenantId, data)
        : tenantsApi.reactivateTenant(tenantId, data);
    },
    onSettled: (_data, _error, variables) => {
      void queryClient.invalidateQueries({ queryKey: tenantsKeys.all });
      void queryClient.refetchQueries({ queryKey: tenantsKeys.detail(variables.tenantId) });
    },
  });

  return {
    toggleStatus: mutation.mutateAsync,
    isToggling: mutation.isPending,
  };
};
